var exports = {
  "x": "TaskListMenuTriggerButton__iL65db",
};

module.exports = exports;
